module.exports = __webpack_public_path__ + "static/littleWomen8s-9c8d6366ba92563461293a1e6b82df96.jpg";